import React, { useEffect } from 'react'
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
} from 'react-router-dom'
import Layout from './layouts/Layout'
import Home from './components/home/Home'
import LogViewer from './components/logviewer/LogViewer'
import Authorize from './components/common/Authorize'
import SessionExpired from './components/common/SessionExpired'
import InternalServerError from './components/common/InternalServerError'
import ConfigurationLayout from './layouts/ConfigurationLayout'
import { useDispatch, useSelector } from 'react-redux'
import * as commonSelectors from './components/common/selectors'
import { commonActions } from './actions/commonActions'
import NotFound from './components/common/error-pages/NotFound'
import ErrorResponse from './components/common/error-pages/ErrorResponse'
import SemaphoreLocks from './components/semaphoreLocks/SemaphoreLocks'
import './styles/custom.css'


export const App = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isAuthorized = useSelector(commonSelectors.isAuthorized);

  useEffect(() => {
    if (pathname === '/') {
      navigate('clientapp');
      return;
    }

    if (isAuthorized === true) {
      dispatch(
        commonActions.checkSession()
      );
    }
  }, [pathname, isAuthorized, dispatch, navigate]);

  return (
    <Routes>
      <Route
        path='clientapp'
        element={
          <Layout />
        }
      >
        <Route
          index
          element={<Home />}
        />
        <Route
          path='configuration/*'
          element={<ConfigurationLayout />}
        />
        <Route
          path='app-logs'
          element={<LogViewer />}
        />
        <Route
          path='semaphoreLocks'
          element={<SemaphoreLocks/>}
        />
        <Route
          path='session-expired'
          element={<SessionExpired />}
        />
        <Route
          path='authorize/:redirectUri'
          element={<Authorize />}
        />
        <Route
          path='error/:statusCode/:requestId'
          element={<ErrorResponse />}
        />
        <Route
          path='internal-server-error'
          element={<InternalServerError />}
        />
        <Route
          path='*'
          element={<NotFound />}
        />
      </Route>
    </Routes>
  );
}

export default App;